<template>
  <v-container fluid fill-width class="container-full-bg-gray" v-if="!isMobile">
    <div>

      <app-modal-prompt 
        v-model="error_dialog"
        @cancel="error_dialog=false"
        @confirm="retryUploadFiles()"
      >

        <template #title>
          Error de subida de ficheros
        </template>

        <template>

          <app-modal-container>
            <app-confirm-modal-title 
              show-title
              text-title="Los siguientes ficheros no se han subido correctamente"
              class="mb-8"
            />
            <app-modal-row justify="center">
              <app-modal-col cols="8">
                <ul>
                  <div v-for="file_name in Object.keys(uploaded_files)" :key="file_name">
                    <li v-if="!uploaded_files[file_name]" class="document-loader__list-element">
                      {{file_name}}
                    </li>
                  </div>
                </ul>
              </app-modal-col>
            </app-modal-row>
          </app-modal-container>

        </template>

        <template #confirm-button-name>
          Reintentar
        </template>

      </app-modal-prompt>

      <app-confirm-modal
        v-model="error_dialog_ext"
        text-center-msg
        show-title
        show-confirm-button
        text-title="Se ha intentado subir un fichero con un formato que no soportamos"
        text-confirm-button="Aceptar"
        :text-msg="wrongFormatMsg"
        :show-text-question="false"
        :show-cancel-button="false"
        @confirm="error_dialog_ext = false"
      />
      
      <app-page-card 
        :class="{dragging_file:dragging_file, 'rounded-xl': true}" 
        :color="dragging_file ? 'var(--v-neutralDark-base)' : ''"
        @drop="dropFiles"
        @dragover="dragging_file=true" 
        @dragleave="dragging_file=false"     
      >

        <template #header>
          {{ $t("GenericDocumentLoader.upload_documents") }}
        </template>
        <template>
              <template>
                
                <app-header-with-subtitle>
                    <template #icon>
                      mdi-file-upload-outline
                    </template>
                    <template>
                      {{ $t("GenericDocumentLoader.title_upload_docs") }}
                    </template>
                    <template #subtitle>
                      {{ $t("GenericDocumentLoader.subtitle") }}
                    </template>
                </app-header-with-subtitle>

                <app-row justify="center">
                  <app-col cols="12" md="8" lg="7" style="padding: 0px">
                    
                    <v-form ref="form" lazy-validation>

                      <app-row>
                        <app-col contains-input-fields cols="12" style="padding: 0px">
                          <v-file-input
                            v-model="files"
                            multiple
                            outlined
                            prepend-icon=""
                            name="uploader"
                            accept=".pdf, .jpg, .png, .zip, .rar, .7z, .tiff, .docx, .doc, .odt, .xls, .xlsx, .xlsm, .ods,.xml,.xsig"
                            :label="$t('GenericDocumentLoader.drag_files')"
                            class="file-input--outlined rounded-lg"
                            :disabled="uploading"
                            :error="!uploading && uploaded_files && Boolean(Object.keys(uploaded_files).length)"
                            @change="removeDuplicates"
                          >
                            <template #prepend-inner>
                              <v-icon color="primary" left>
                                mdi-paperclip
                              </v-icon>
                            </template>
                            <template #append>
                              <v-icon
                                color="error"
                                v-if="!uploading && uploaded_files && Boolean(Object.keys(uploaded_files).length)"
                                @click="error_dialog=!error_dialog"
                              >
                                mdi-alert
                              </v-icon>
                            </template>
                          </v-file-input>
                        </app-col>
                      </app-row>

                      <div style="display: flex; align-items: center; width: 115%; height: 15vh; padding: 0px">
                        <div style="width: 30%; margin-right: 5%">
                          <div class="cabeceras">
                            {{$t('GenericDocumentLoader.document_type')}}
                          </div>
                          <v-select 
                            v-model="doc_type"
                            :placeholder="$t('GenericDocumentLoader.document_type')"
                            :items="screen_data.availableTypes"
                            name="selectorTipoDoc"
                            outlined
                            @change="
                              updateDocType()
                            "
                            style="width: 100%;"
                          >
                            <template v-slot:item="data">
                              <v-list-item
                                v-bind="data.attrs"
                                @click="data.on.click"
                              >
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <template v-if="data.item === 'add_type'">
                                      <div style="display: flex; align-items: center;">
                                        <AppIcon :src="require('@/assets/add_circle.svg')" :size="29" style="height: 28px; width: 28px;" />
                                        <span class="primary--text font-weight-medium" style="margin-left: 1vw">{{ $t("GenericDocumentLoader.add_type") }}</span>
                                      </div>
                                    </template>
                                    <template v-else>
                                      {{ fortmattedToChangeLanguage(data.item)? $t("GenericDocumentLoader."+fortmattedToChangeLanguage(data.item)):  data.item}}
                                    </template>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-select>
                        </div>

                        <div style="width: 30%; margin-right: 5%; padding-bottom: 4vh;" v-if="screen_data && screen_data.companyFolders">
                          <div class="cabeceras">
                            {{ $t("GenericDocumentLoader.select_location") }}
                          </div>
                          <button
                            type="button"
                            style="border: 1px solid #aaaaaa; width: 100%; height: 55px; border-radius: 3px; display: flex; align-items: center; margin-bottom: 3px;"
                            @click="popup_select_folder = true"
                          >
                            <span style="text-align: left; padding-left: 1vw; width: 88%; color:black">
                              {{name_selected_folder}}
                            </span>
                            <v-icon style="height: 14px; width: 14px;">mdi-menu-down</v-icon>
                          </button>
                          <v-dialog persistent max-width="600"
                            v-model="popup_select_folder"
                          >
                            <v-card>
                                <v-card-title class="text-center" >
                                    {{ $t("ViesValidator.select_folder") }}
                                </v-card-title>

                                <v-card-text>
                                    <FolderSelectorComponent
                                        :items="screen_data.companyFolders"
                                        v-model="selected_folder"
                                        :show_selected_route="false"
                                        :initial_selected_folder="selected_folder"
                                    />
                                </v-card-text>
                                <v-card-actions class="action_btns">
                                    <v-spacer></v-spacer>
                                    <v-btn 
                                        outlined
                                        @click="popup_select_folder = false"
                                        class="action_btn"
                                        >
                                        {{$t("GenericDocumentLoader.cancel")}}
                                    </v-btn>
                                    <v-btn 
                                        color="primary_blue"
                                        class="white--text action_btn"
                                        :disabled="selected_folder == null"
                                        :loading="screen_data.loading_d_other_doc"
                                        @click="changeSelectedFolder()"
                                        >
                                        {{$t("GenericDocumentLoader.accept")}}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </div>

                        <!-- <v-col 
                          class="pa-0 text-center" 
                          :cols="isMobile ? 2 : 1"
                        >

                          <v-tooltip top v-if="staff_or_loginas">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn 
                                @click="screen_data.docTypesDialog = true"
                                v-bind="attrs"
                                v-on="on"
                                color="primary"
                                icon 
                                x-large
                                style="margin-top: 5px;margin-left: -10px;"
                                >
                                <v-icon class="material-symbols-outlined">add</v-icon>                
                              </v-btn>
                            </template>
                            <span>Añadir tipo</span>
                          </v-tooltip>

                        </v-col> -->

                        <div style="width: 30%; margin-right: 5%">
                          <div class="cabeceras">
                            Workflow
                          </div>
                          <v-select
                            v-model="workflow"
                            placeholder="Workflow" 
                            item-value="id" 
                            item-text="name"
                            :items="docWorkflowOptions" 
                            outlined
                            name="selectorWorkflow"
                            :disabled="doc_type == ''"
                          />
                        </div>
                          <!-- To show credit cost, use this: :messages="showCost" -->

                        <div style="width: 10%;">
                          <v-tooltip top v-if="staff_or_loginas">
                            <template v-slot:activator="{ on, attrs }">                
                              <v-btn 
                                @click="goToWfTemplatesList"
                                v-bind="attrs"
                                v-on="on"
                                color="primary"
                                icon 
                                x-large
                                >
                                <v-icon>mdi-cog-outline</v-icon>                  
                              </v-btn>
                            </template>
                            <span>{{$t("GenericDocumentLoader.edit_workflows")}}</span>
                          </v-tooltip>
                        </div>

                        <!-- <app-col contains-input-fields has-input-fields-above cols="12" sm="6" md="4">
                          <v-select v-model="period_type_list"  label="Periodo" item-value="id" item-text="text" 
                            :items="DOCUMENT_PERIOD_OPTIONS"
                            name="selectorPeriodo"
                            @change="period_changed"
                            outlined
                          ></v-select>
                        </app-col>

                        <app-col contains-input-fields has-input-fields-above cols="12" sm="6" md="4"
                          v-if="period_options_list"
                          >
                          <v-select
                            v-model="period"  
                            label="Fecha periodo" 
                            item-value="id" 
                            item-text="text" 
                            :items="period_options_list"
                            name="selectorPeriodo"
                            outlined
                          ></v-select>
                        </app-col>
                        <app-col contains-input-fields has-input-fields-above cols="12" sm="6" md="4" 
                          v-if="period_type_list == 'annual' && period_options_list == undefined"
                          >
                          <app-text-field
                            v-model="period"
                            label="Fecha anual (YYYY)"
                          />
                        </app-col> -->
                      </div>

                      <app-row justify="center">
                        <app-col has-input-fields-above cols="12" sm="6" md="4" class="text-center">
                          <app-btn x-large 
                            name="subir" 
                            :disabled="cant_upload"
                            color="primary" 
                            @click="uploadFiles" 
                            :loading="uploading"
                          >
                            {{$t("GenericDocumentLoader.upload_documents")}}
                          </app-btn>
                          <div style="color: red; font-size: 12px; margin-top: 6px;" v-if="not_enough_credits">
                            No tienes créditos suficientes para subir los documentos seleccionados.
                          </div>
                        </app-col>
                      </app-row>
                                 
                    </v-form>

                  </app-col>
                </app-row>

              </template>
        </template>

      </app-page-card>

      <v-snackbar
          v-model="snackbar.isVisible"
          :color="snackbar.color"
          :timeout="snackbar.timeout"
      >
          {{ snackbar.text }}
      </v-snackbar>

      <v-dialog persistent v-if="screen_data.availableTypes" v-model="screen_data.docTypesDialog" max-width="800">

        <v-card>

          <v-card-title class="headline">
            <span class="text-h6 primary__blue py-1 ml-2">{{ $t("GenericDocumentLoader.types_of_documents") }}</span>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="border-lg mt-4 px-8">
            <v-row  class="table-head-row">

              <v-col class="pa-0 ma-0">
                <v-divider></v-divider>
                <v-row class="table-head-row flex-sm-nowrap d-flex align-center justify-center" no-gutters>
                  <v-divider vertical></v-divider>
                  <div class="col pa-3">{{ $t("GenericDocumentLoader.name") }}</div>
                  <v-divider vertical></v-divider>
              </v-row>
                <v-divider></v-divider>
              </v-col>

            </v-row>

            <v-row class="table__border">
              <v-col class="ma-0 pa-0" cols="12" v-for="(type, index) in screen_data.availableTypes" v-bind:key="index">
                <div class="d-flex pa-0 ma-0 flex-sm-nowrap ">
                  <v-divider vertical></v-divider>
                  <div class="d-flex align-center justify-center">
                    <v-btn icon color="#4c4c4c" @click="screen_data.availableTypes.splice(index, 1)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                  <v-divider vertical></v-divider>
                  <div class="d-flex align-center justify-center px-2 asd" :class="index % 2 == 0? 'bg__gray__2': 'bg__gray'">
                    {{ index + 1 }}
                  </div>
                  <v-divider vertical></v-divider>
                  <v-text-field
                    @input="updateType($event, index)"
                    :value="translatedType(index)"
                    filled
                    dense
                    flat
                    solo
                    hide-details
                  ></v-text-field>
                  <!-- <v-text-field
                    v-model="screen_data.availableTypes[index]"
                    filled
                    dense
                    flat
                    solo
                    hide-details
                  ></v-text-field> -->
                  <v-divider vertical></v-divider>
                </div>
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6">
                <v-btn outlined small
                  @click="component.addDocType()"
                  >
                  <v-icon v-once>mdi-plus</v-icon>
                  {{ $t("GenericDocumentLoader.add_type") }}
                </v-btn>
              </v-col>
            </v-row>
            
          </v-card-text>

          <v-card-actions class="mx-6 pb-8">
            <v-spacer></v-spacer>
            <v-btn outlined @click="component.cancelSaveDocType()" class="action__btn">Cerrar</v-btn>
            <v-btn 
                color="primary_blue"
                class="white--text action__btn"
                :disabled="canSave"
                @click="component.saveDocTypes()"
                :loading="screen_data.loadingSave"
                >
                Guardar
            </v-btn>
          </v-card-actions>

        </v-card>

      </v-dialog>

    </div>
  </v-container>
  <div v-else="" style="background-color: #FFFFFF; width: 100%; height: 100%; overflow-y: auto; border-top-left-radius: 10px; border-top-right-radius: 10px">
    <div style="padding: 15px 20px">
      <span style="font-family: Roboto; font-weight: 600; font-size: 20px; color: var(--v-primaryDark-base);">
        {{$t('GenericDocumentLoader.upload_documents')}}
      </span>
    </div>
    <v-divider/>
    <div style="padding: 0px 35px;">
      <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center;">
        <AppIcon :src="require('@/assets/upload_file_purple.svg')" :size="29" style="height: 28.82; width: 21.22px; margin-top: 40px;" />
        <span style="font-family: Roboto; font-weight: 600; font-size: 26px; color: var(--v-primary-base); margin-top: 5px;">
          {{$t('GenericDocumentLoader.title_upload_docs')}}
        </span>
        <span style="font-family: Roboto; font-weight: 500; font-size: 20; color: #565656; margin-top: 20px;">
          {{$t('GenericDocumentLoader.subtitle')}}
        </span>
      </div>

      <v-file-input
        v-model="files"
        multiple
        outlined
        prepend-icon=""
        name="uploader"
        accept=".pdf, .jpg, .png, .zip, .rar, .7z, .tiff, .docx, .doc, .odt, .xls, .xlsx, .xlsm, .ods,.xml,.xsig"
        :label="$t('GenericDocumentLoader.drag_files_mobile')"
        class="file-input--outlined-mobile"
        style="margin-top: 60px;"
        :disabled="uploading"
        :error="!uploading && uploaded_files && Boolean(Object.keys(uploaded_files).length)"
        @change="removeDuplicates"
      >
        <template #prepend-inner>
          <AppIcon :src="require('@/assets/attach_file_add.svg')" :size="29" style="height: 19px; width: 13.34px; margin-right: 5px;" />
        </template>
        <template #append>
          <v-icon
            color="error"
            v-if="!uploading && uploaded_files && Boolean(Object.keys(uploaded_files).length)"
            @click="error_dialog=!error_dialog"
          >
            mdi-alert
          </v-icon>
        </template>
      </v-file-input>

      <div class="cabeceras-mobile">
        {{$t('GenericDocumentLoader.document_type')}}
      </div>
      <v-select 
        v-model="doc_type"
        :placeholder="$t('GenericDocumentLoader.document_type')"
        :items="screen_data.availableTypes"
        name="selectorTipoDoc"
        outlined
        @change="
          updateDocType()
        "
        dense
        class="selects-mobile"
      >
        <template v-slot:item="data">
          <v-list-item
            v-bind="data.attrs"
            @click="data.on.click"
          >
            <v-list-item-content>
              <v-list-item-title>
                <template v-if="data.item === 'add_type'">
                  <div style="display: flex; align-items: center;">
                    <AppIcon :src="require('@/assets/add_circle.svg')" :size="29" style="height: 28px; width: 28px;" />
                    <span class="primary--text font-weight-medium" style="margin-left: 1vw">{{ $t('GenericDocumentLoader.add_type') }}</span>
                  </div>
                </template>
                <template v-else>
                  {{ fortmattedToChangeLanguage(data.item)? $t("GenericDocumentLoader."+fortmattedToChangeLanguage(data.item)):  data.item }}
                </template>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-select>

      <div class="cabeceras-mobile" style="margin-top: 15px">
        {{ $t('GenericDocumentLoader.select_location') }}
      </div>
      <v-select
        :placeholder="name_selected_folder"
        dense
        outlined
        class="select-fake-mobile"
        @click="popup_select_folder = true"
      />

      <v-dialog persistent max-width="600"
        v-model="popup_select_folder"
      >
        <v-card>
            <v-card-title class="text-center" >
                {{ $t('GenericDocumentLoader.select_folder') }}
            </v-card-title>

            <v-card-text>
                <FolderSelectorComponent
                    :items="screen_data.companyFolders"
                    v-model="selected_folder"
                    :show_selected_route="false"
                    :initial_selected_folder="selected_folder"
                />
            </v-card-text>
            <v-card-actions class="action_btns">
                <v-spacer></v-spacer>
                <v-btn 
                    outlined
                    @click="popup_select_folder = false"
                    class="action_btn"
                    >
                    {{$t("ViesValidator.cancel")}}
                </v-btn>
                <v-btn 
                    color="primary_blue"
                    class="white--text action_btn"
                    :disabled="selected_folder == null"
                    :loading="screen_data.loading_d_other_doc"
                    @click="changeSelectedFolder()"
                    >
                    {{$t("ViesValidator.accept")}}
                </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="cabeceras-mobile" style="margin-top: 15px">
        Workflow
      </div>
      <v-select
        v-model="workflow"
        placeholder="Workflow" 
        item-value="id" 
        item-text="name"
        :items="docWorkflowOptions" 
        outlined
        name="selectorWorkflow"
        :disabled="doc_type == ''"
        dense
        class="selects-mobile"
      >
        <template v-slot:item="{ item }">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                {{ fortmattedToChangeLanguage(item.name)? $t('GenericDocumentLoader.'+fortmattedToChangeLanguage(item.name)): item.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-select>
      <div style="display: flex; justify-content: center; margin-top: 20px">
        <button 
          :style="{
            backgroundColor: !files || !doc_type?'rgb(224 224 224)': '#512A79',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '40px',
            width: '160px',
            marginTop: '40px',
          }"
          :disabled="cant_upload"
          :loading="uploading"
          @click="uploadFiles" 
        >
          <v-progress-circular
            v-if="uploading"
            indeterminate
            size="20"
            width="2"
            color="white"
          />
          <span 
            v-else
            :style="{
              fontFamily: 'Roboto',
              fontWeight: '500',
              fontSize: '14px',
              color: !files || !doc_type?'rgb(166 166 166)':'white',
            }"
          >
            {{$t("GenericDocumentLoader.upload_documents")}}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppAutocomplete from '@/components/layout/AppAutocomplete.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppBtn from '@/components/layout/AppBtn.vue';
import AppHeaderWithSubtitle from '@/components/layout/AppHeaderWithSubtitle.vue';
import AppPageCard from '@/components/layout/AppPageCard.vue';
import AppSelect from '@/components/layout/AppSelect.vue';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue';
import AppConfirmModalTitle from '@/components/layout/AppConfirmModalTitle.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import { mapGetters, mapState, mapActions } from "vuex"
import { mapFields } from 'vuex-map-fields';
import { OTHER_DOCUMENT_TYPES,
  DOCUMENT_PERIOD_OPTIONS,
  DOCUMENT_PERIOD_OPTIONS_MONTHLY,
  DOCUMENT_PERIOD_OPTIONS_QUARTERLY } from '../store/constants.js';
import awsconfig from '../aws-exports';
import { async_command_dispatcher, query_dispatcher, sync_command_dispatcher } from "@/api/client";
import { S3Repository, MemoryS3Repository } from '@/modules/shared/infra/S3Repository';
import { CreateDocumentsCommand } from "@/modules/document/application/CreateDocumentsCommand"
import { WorkflowTemplatesQuery } from "@/modules/document/application/WorkflowTemplatesQuery";
import { VueOtherDocumentLoaderScreenData } from '@/modules/document/infra/VueOtherDocumentLoaderScreenData.ts';
import { ApiOtherDocumentRepository } from '@/modules/document/infra/ApiOtherDocumentRepository.ts';
import { OtherDocLoaderComponent } from '@/modules/document/application/OtherDocLoaderComponent.ts';
import FolderSelectorComponent from "@/components/FolderSelectorComponent";
import { isMobile } from 'filestack-js';

export default {
  components: {
    AppAutocomplete,
    AppBtn,
    AppConfirmModal,
    AppConfirmModalTitle,
    AppModalContainer,
    AppModalRow,
    AppModalCol,
    AppHeaderWithSubtitle,
    AppModalPrompt,
    AppPageCard,
    AppSelect,
    AppTextField,
    AppRow,
    AppCol,
    FolderSelectorComponent
  },

  data() {
    const screen_data = new VueOtherDocumentLoaderScreenData()
    return {
      creds: undefined,

      DOCUMENT_PERIOD_OPTIONS,
      DOCUMENT_PERIOD_OPTIONS_MONTHLY,
      DOCUMENT_PERIOD_OPTIONS_QUARTERLY,
      OTHER_DOCUMENT_TYPES,
      files: null,
      snackbar: {
        isVisible: false,
        text: '',
        color: '',
        timeout: 2000,
      },
      uploading: false,
      dragging_file: false,
      uploaded_files: {},
      uploading_file: '',
      error_dialog: false,
      error_dialog_ext: false,
      dialog_err_txt:'',
      error_uploading: false,
      period_type_list: undefined,
      period_options_list: undefined,
      period: undefined,
      doc_type:'',
      workflowOptions:[{'name':'Sin workflow', 'id':0}],
      workflow: 0,
      screen_data: screen_data,
      component: null,
      selected_folder: null,
      folders: null,
      popup_select_folder: false,
      name_selected_folder: '',
    };
  },
  props: {
    companydb_id: {
      type: [Number, String],
      required: true,
      default: null
    }
  },
  watch: {
    companydb_id(newVal){
      this.component.getCompanyFolders(newVal)
      this.name_selected_folder = this.$t('GenericDocumentLoader.my_unit')
      this.selected_folder = "Mi unidad"
    }
  },

  computed:{
    ...mapFields(['projects', 'channels', 'activities', 'default_activity']),
    ...mapState(['session_information']),
    ...mapGetters({
      me: 'me/me',
      userData: 'me/userData',
      got_feature: 'got_feature',
    }),
    cant_upload(){
      return !this.files || this.files.length == 0 || !this.doc_type || this.screen_data.saldo === null || this.not_enough_credits
    },
    not_enough_credits(){
      return this.files && this.screen_data && this.screen_data.saldo != null &&  this.files.length > this.screen_data.saldo
    },
    docWorkflowOptions() {
      let options = []
      this.workflowOptions.forEach((option) => {
        let newOption = { ...option }
        if(option.trigger_entity_type_uuid == null){
          newOption.name = this.fortmattedToChangeLanguage(newOption.name)? this.$t('GenericDocumentLoader.'+this.fortmattedToChangeLanguage(newOption.name)): newOption.name
          options.push(newOption)
        }
      })
      return options
      // return this.workflowOptions.filter((option) => option.trigger_entity_type_uuid == null)
    },
    staff_or_loginas() {
      return this.userData.is_staff || (this.userData.hasOwnProperty('username') && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username))
    },
    wrongFormatMsg() {
      return `Los formatos soportados son: xls, xlsx, xlsm, ods, jpg, jpeg, png, zip, pdf, tif, 7z y rar.`
    },
    canSave() {
      return this.screen_data.availableTypes.length == 0 || this.screen_data.availableTypes.some((type) => type == '')
    },
    showCost() {
      let selectedWorkflow = this.workflowOptions.find((option) => option.id == this.workflow)
      if (selectedWorkflow && selectedWorkflow.stages) {
        return 'Coste: ' + selectedWorkflow.stages.reduce((totalCost, stage) => totalCost + stage.price, 0) + ' créditos'
      }
      return ''
    },
    isMobile () {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  async mounted() {
    this.selected_folder = this.$route.query.selected_folder
    this.name_selected_folder = this.fortmattedToChangeLanguage(this.$route.query.name_folder_selected)? this.$t('GenericDocumentLoader.'+this.fortmattedToChangeLanguage(this.$route.query.name_folder_selected)) : this.$route.query.name_folder_selected

    let other_docs_repo = new ApiOtherDocumentRepository()
    this.component = new OtherDocLoaderComponent(other_docs_repo, this.screen_data)
    this.component.getAvailableCredits()
    await this.component.mount(this.companydb_id)
    this.screen_data.availableTypes.push("add_type")
  },
  async created(){
    await new WorkflowTemplatesQuery(query_dispatcher, this).run()
    
  },
  methods:{
    ...mapActions({
      waitForLoggedIn: "waitForLoggedIn",
      refreshUserData: "me/refreshUserData"
      }),
    dropFiles(e){  
      if (this.files == null) {
        this.files = Array();
      }
      let new_files = Array.from(e.dataTransfer.files);
      var duplicated_file = false;
      var empty_file = false;
      new_files.forEach((item_new_file) => {
        if (item_new_file.size == 0) {
          empty_file = true;
        }
        else if (!(this.files.some((item_file) => item_file.name === item_new_file.name && item_file.size === item_new_file.size))) {
          this.files.push(item_new_file);
        }
        else {
          duplicated_file = true;
        }          
      });
      if (empty_file) {
        alert("Alguno de los archivos tiene tamaño 0. Comprueba que no estas arrastrando los archivos directamente desde dentro de un archivo comprimido.");
      }
      if (duplicated_file) {
        alert("Los archivos duplicados solo se subirán una vez");
      }    
      this.dragging_file = false;
      e.preventDefault();
    },
    goToWfTemplatesList(){
      this.$router.push({name: 'workflow-list'})
    },
    removeDuplicates(files) {      
      if (files.length > 1) {
        let uniqueFiles = files.filter((item, index, array) => array.findIndex(t => t.name == item.name && t.size == item.size) == index);
        if (uniqueFiles.length != files.length) {
          alert("Los archivos duplicados solo se subirán una vez");
        }
        this.files = uniqueFiles;
      }              
    },
    async uploadFiles(e) {
      try {
        this.creds = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
        });
        this.creds.params.Logins = this.creds.params.Logins || {};
        this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] =  this.session_information.signInUserSession.idToken.jwtToken;
        this.creds.expired = true;
        AWS.config.update({
            region: awsconfig['aws_user_files_s3_bucket_region'],
            credentials: this.creds,
          });
        if (this.selected_folder == 'Mi unidad') {
          this.selected_folder = null
        }
        this.files = await new CreateDocumentsCommand(async_command_dispatcher, new S3Repository(AWS, 'odocs'), this).run(this.files, this.doc_type, this.companydb_id, this.userData.id, this.selected_folder)

        // this.files = await new CreateDocumentsCommand(sync_command_dispatcher, new MemoryS3Repository(), this).run(this.files, this.doc_type, this.currentCompany.id, this.userData.id)
        this.doc_type=null
      } catch (error) {
        console.error('Error upload documents', error);
      }
    },
    retryUploadFiles() {
      this.error_dialog=false
      this.uploading = true;
      let retry_files = []
      for (let i in this.files) {
        if (!this.uploaded_files[this.files[i].name]) {
          retry_files.push(this.files[i])
        }
      }
      this.files = retry_files;
      this.uploadFiles();
    },
    isValidExtension(ext){
      let valid_ext = ['pdf','jpg','jpeg','png','zip','rar','7z','tiff','xls', 'xlsx', 'xlsm', 'ods','xml','xsig','docx', 'doc', 'odt']
      return valid_ext.includes(ext.toLowerCase())
    },
    setSnackbar(color, text) {
      this.snackbar.text = text
      this.snackbar.color = color
      this.snackbar.isVisible = true
    },
    period_changed() {
      if(this.period_type_list == 'monthly'){
        this.period_options_list = DOCUMENT_PERIOD_OPTIONS_MONTHLY
      }else if (this.period_type_list == 'quarterly'){
        this.period_options_list = DOCUMENT_PERIOD_OPTIONS_QUARTERLY
      }else {
        this.period_options_list = undefined
      }
    },
    updateDocType() {
      if (this.doc_type === 'add_type') {
        this.screen_data.availableTypes = this.screen_data.availableTypes.filter(type => type !== 'add_type');
        this.screen_data.docTypesDialog = true;
        this.$nextTick(() => {
          this.doc_type = null;
        })
        return;
      }
      let found = false;
      for (const option of this.workflowOptions) {
        if (option.default_doc_types && option.default_doc_types.includes(this.doc_type)) {
          this.workflow = option.id;
          found = true;
          break;
        }
      }
      if (!found) {
        this.workflow = 0;
      }
    },
    changeSelectedFolder(){
      this.name_selected_folder = this.getFolderRoute(this.screen_data.companyFolders, this.selected_folder)
      this.popup_select_folder = false;
    },
    getFolderRoute(folders, folder_uuid) {
      for (let i = 0; i < folders.length; i++) {
        if (folders[i].id == folder_uuid) {
          return folders[i].name;
        }

        if (folders[i].children && folders[i].children.length > 0) {
          const result = this.getFolderRoute(folders[i].children, folder_uuid);
          if (result) {
            return result;
          }
        }
      }
      return null;
    },
    fortmattedToChangeLanguage(text){
      switch(text){
        case "Nómina":
          return "payroll"
        case "Contrato":
          return "contract"
        case "Modelos/Impuestos":
          return "taxes_and_models"
        case "Certificado":
          return "certificate"
        case "Facturas":
          return "invoices"
        case "Otros":
          return "others"

        case "Mi unidad":
          return "my_unit"

        case "Sin workflow":
          return "no_workflow"

        default:
          return ""
      }
    },
    translatedType(index){
      let value = this.screen_data.availableTypes[index]
      value = this.fortmattedToChangeLanguage(value)? this.$t("GenericDocumentLoader."+this.fortmattedToChangeLanguage(value)): value
      return value
    },
    updateType(newVal, index){
      this.$set(this.screen_data.availableTypes, index, newVal)
    }
  }
};
</script>

<style scoped>
  .cabeceras {
    font-family: Roboto;
    font-weight: 500;
    font-size: 14px;
    color: #565656;
    margin-bottom: 5px;
  }

  .cabeceras-mobile {
    font-family: Roboto;
    font-weight: 500;
    font-size: 12px;
    color: #565656;
    margin-bottom: 5px;
  }

  .selects-mobile .v-select__selections{
    width: 100%;
  }

  .action_btns {
    display: flex !important;
    justify-content: space-between !important;
    padding: 0 24px 20px;
  }

  .action_btn {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    border-radius: 20px;
    padding: 18px !important;
    gap: 8px;
    text-transform: capitalize;
  }
</style>

<style>
.invalid .v-select__slot {
  background-color: red
}
.invalid .v-text-field__slot {
  background-color: red
}
.title-color {
  color:var(--v-primary-base);
}

.dragging_file{
  background: var(--v-neutralDark-base)!important;
  border-radius: 5px;
  border: 2px dashed #ccc;
}

.primary-bckground {
  background-color: var(--v-primary-base);
}
.primary-border {
  border-color: var(--v-primary-base) !important;
}

.file-input--outlined.v-text-field--outlined:not(.error--text) fieldset {
  border-color: var(--v-primary-base);
}

.file-input--outlined-mobile.v-text-field--outlined:not(.error--text) fieldset {
  border-color: var(--v-primary-base);
  padding: 0;
}

.file-input--outlined-mobile .v-input__slot{
  /* padding: 0px 20px !important;
  border: 1px solid var(--v-primaryDark-base) !important; */
}

.select-fake-mobile input::placeholder{
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  color: black !important;
}

.select-fake-mobile .v-messages.theme--light{
  display: none;
}

.select-fake-mobile .v-text-field__details{
  display: none;
}

.selects-mobile .v-select__selections{
  padding: 0px !important;
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  color: #565656 !important;
}

.selects-mobile .v-select__selection--comma{
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  color: black !important;
}

.selects-mobile .v-messages.theme--light{
  display: none;
}

.selects-mobile .v-text-field__details{
  display: none;
}


.file-input--outlined > .v-input__control > .v-input__slot {
  -webkit-box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
  box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
}

.document-loader__list-element {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}

.table-head-row {
  position:sticky;
  top:0;
  z-index: 1;
  background-color: #F4F4F4;
  font-weight: 600;
}

.asd {
  width: 25px
}

.bg__gray{
  background-color: rgba(217, 217, 217, 0.502);
}
.bg__gray__2 {
  background-color: #d9d9d9;
}
.action__btn {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  border-radius: 20px;
  padding: 18px !important;
  gap: 8px;
  text-transform: capitalize;
}
</style>